module.exports = __webpack_public_path__ + "img/s14.be1ab12.png";